import fetchJsonp from 'fetch-jsonp';

// get请求 
export let getFetch = async (url) => {
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/x-www-form-urlencoded'); 
    try { 
        let response = await fetch(url, { 
            method: 'GET', 
            headers: headers,
            mode: 'no-cors' 
        });
        let json = await response.json();
        return json; 
    } catch (err) {
        return { 
            code:1040, 
            msg:"数据加载失败" 
        } 
    } 
} 

// post请求 （json字符串参数）
export let postFetch = async (url, body) => { 
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/json');
    try { 
        let response = await fetch(url, { 
            method: 'POST',
            // mode: 'no-cors', 
            headers: headers, 
            body:JSON.stringify(body) 
        }); 
        let json = await response.json(); 
        return json; 
    }catch (err) { 
        return { 
            code:1040, 
            msg:"接口请求出错" 
        } 
    } 
};

// post请求formData格式数据 
export let postFormFetch = async (url, body) => {
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/json'); 
    try { 
        let response = await fetch(url, { 
            method: 'POST',
            mode: 'no-cors', 
            headers: headers, 
            body:body
        }); 
        let json = await response.json(); 
        return json; 
    }catch (err) { 
        return { 
            code:1040, 
            msg:"接口请求出错" 
        } 
    } 
}; 


//put请求 
export let putFetch = async (url,body) => { 
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/json'); 
    try { 
        let response = await fetch(url, { 
            method:'PUT', 
            headers:headers,
            mode: 'no-cors',  
            body:JSON.stringify(body) 
        }); 
        let json = await response.json(); 
        return json; 
    } catch(err){ 
        return { 
            code:1040, 
            msg:"数据修改失败" 
        } 
    } 
}; 

//patch请求 
export let patchFetch = async (url,body) => { 
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/json'); 
    try { 
        let response = await fetch(url, { 
            method:'PATCH', 
            headers:headers,
            body:JSON.stringify(body),
            mode: 'no-cors'  
        }); 
        let json = await response.json(); 
        return json; 
    }catch(err){
        return { 
            code:1040, 
            msg:"数据修改失败" 
        } 
    } 
}; 

//delete请求 
export let deleteFetch = async (url) => { 
    //添加请求头 
    let headers = new Headers(); 
    headers.append('Content-Type','application/json'); 
    try { 
        let response = await fetch(url, { 
            method:'DELETE', 
            headers:headers,
            mode: 'no-cors'  
        }); 
        let json = await response.json(); 
        return json; 
    }catch(err){ 
        return { 
            code:1040, 
            msg:"数据修改失败" 
        } 
    } 
};  

// jsonp请求 
export let getJsonp = async (url, params) => {
    try { 
        let headers = new Headers(); 
        let response = await fetchJsonp(url,{
            credentials:"include",
            headers:headers,
            cache:'default'
        });
        let json = await response.json();
        return json; 
    } catch (err) {
        return { 
            code:1040, 
            msg:"数据加载失败" 
        } 
    } 
}
